import { render } from "./CreateTransferFrom.vue?vue&type=template&id=368e109e"
import script from "./CreateTransferFrom.vue?vue&type=script&lang=js"
export * from "./CreateTransferFrom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__